import { render } from "./kyc.vue?vue&type=template&id=2543bd45&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"

import "./kyc.vue?vue&type=style&index=0&id=2543bd45&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2543bd45"]])

export default __exports__